import * as React from "react";
import { Button } from "../../../../components/ui/button";
import { Pencil, Trash2 } from "lucide-react";

export function VehicleListItem({
  vehicle,
  index,
  onEdit,
  onDelete,
}) {
  return (
    <div className="rounded-md border p-3 text-sm flex items-center justify-between">
      <div>
        <div className="font-medium">
          {index + 1}. {vehicle.year} {vehicle.make} {vehicle.model}
        </div>
        <div className="text-xs text-gray-500">
          VIN {vehicle.vin} · Body {vehicle.bodyType} · Class {vehicle.class} · $
          {Number(vehicle.value ?? 0).toLocaleString()}
        </div>
        {vehicle._ageError && (
          <div className="mt-2 text-sm flex items-center gap-2 rounded border border-red-600 bg-red-50 text-red-700 px-3 py-2">
            <span>⚠</span>{vehicle._ageError}
          </div>
        )}
      </div>

      <div className="flex items-center gap-2">
        <Button variant="outline" size="sm" onClick={onEdit}>
          <Pencil className="h-4 w-4 mr-1" /> Edit
        </Button>
        <Button variant="destructive" size="sm" onClick={onDelete}>
          <Trash2 className="h-4 w-4 mr-1" /> Delete
        </Button>
      </div>
    </div>
  );
}
